import actionTypes from './actionTypes';

export const requestUserPasswordReset = data => ({
  type: actionTypes.REQUEST_USER_PASSWORD_RESET,
  data,
});

export const userPasswordResetSuccess = () => ({
  type: actionTypes.USER_PASSWORD_RESET_SUCCESS,
});

export const userPasswordResetFailure = () => ({
  type: actionTypes.USER_PASSWORD_RESET_FAILURE,
});

export const requestEmailVerificationLink = () => ({
  type: actionTypes.REQUEST_EMAIL_VERIFICATION_LINK,
});

export const getEmailVerificationLinkSuccess = () => ({
  type: actionTypes.GET_EMAIL_VERIFICATION_LINK_SUCCESS,
});

export const getEmailVerificationLinkFailure = () => ({
  type: actionTypes.GET_EMAIL_VERIFICATION_LINK_FAILURE,
});

export const requestUserTokenPersist = data => ({
  type: actionTypes.REQUEST_USER_TOKEN_PERSIST,
  data,
});

export const persistUserTokenSuccess = () => ({
  type: actionTypes.USER_TOKEN_PERSIST_SUCCESS,
});

export const persistUserTokenFailure = () => ({
  type: actionTypes.USER_TOKEN_PERSIST_FAILURE,
});

export const requestUserAuthTokenExchange = data => ({
  type: actionTypes.REQUEST_USER_AUTH_TOKEN_EXCHANGE,
  data,
});

export const userAuthTokenExchangeSuccess = () => ({
  type: actionTypes.USER_AUTH_TOKEN_EXCHANGE_SUCCESS,
});

export const userAuthTokenExchangeFailure = () => ({
  type: actionTypes.USER_AUTH_TOKEN_EXCHANGE_FAILURE,
});

export const requestUserRegister = data => ({
  type: actionTypes.REQUEST_USER_REGISTER,
  data,
});

export const userRegisterSuccess = data => ({
  type: actionTypes.USER_REGISTER_SUCCESS,
  data,
});

export const userRegisterFailure = () => ({
  type: actionTypes.USER_REGISTER_FAILURE,
});

export const retrieveLoggedInUser = () => ({
  type: actionTypes.REQUEST_LOGGED_IN_USER,
});

export const loggedInUserSuccess = (data?: object) => ({
  type: actionTypes.LOGGED_IN_USER_GET_SUCCESS,
  data,
});

export const loggedInUserFailure = () => ({
  type: actionTypes.LOGGED_IN_USER_GET_FAILURE,
});

export const forbiddenUser = () => ({
  type: actionTypes.LOGGED_IN_USER_FORBIDDEN,
});

export const triggerLogout = () => ({
  type: actionTypes.TRIGGER_LOGOUT,
});

export const logoutSuccess = () => ({
  type: actionTypes.LOGOUT_SUCCESS,
});
